import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom'

function Banner() {

  const [scrollY, setScrollY] = useState(0);

  const handleScroll = () => {
    setScrollY(window.scrollY);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div style={{marginTop: "60px"}}>
        <div
          className="indexHeaderBannersContainer"
          style={{
            backgroundPosition: `center ${scrollY * 0.05}px`, // ปรับตำแหน่งของพื้นหลัง
          }}
        >
          <div className="indexBannerBody">
            <h1>ระบบแจ้งซ่อมภายในองค์กร</h1>
            <p>
              งานติดตั้ง และซ่อมบำรุง - อุปกรณ์ความปลอดภัย - บริการซักรีด และทำความสะอาดชุดยูนิฟอร์ม - บริการเช่ายืมอุปกรณ์ SCBA อุปกรณ์ช่วยเหลือฉุกเฉิน อุปกรณ์ดับเพลิง เครื่องวัดแอลกอฮอล์ เครื่องวัด แสง สี เสียง - บริการด้านออกแบบสื่อโฆษณา ผลิตงานป้าย ออกแบบเว็บไซต์ และพัฒนาระบบ
            </p>
          </div>
        </div>
        <div style={{marginTop: "80px"}} className='indexHeaderContentsContainer'>
            <h4 className='headTopoics_H4'> บริการของเรา <span className='bannerHeadSectionLogo'>PIYAMANEE SERVICE</span></h4>
            <div className='indexHeaderControllerGrid'>
              <div style={{display: "grid" , height: "max-content"}} className='indexGridRows'>
                <div className='indexBoxItems'>
                  <h6><i class="fa-solid fa-file-shield"></i> ANTIVIRUS SOLUTIONS</h6>
                  <div className='indexLiDesc'>
                    <li>ANTIVIRUS STATIONS : สถานีสำหรับผ่านฆ่าเชื้อไวรัส</li>
                    <li>GEL STATIONS : สถานีสำหรับกดน้ำยา</li>
                    <li>DISINFECTION LIQUID : น้ำยาฆ่าเชื้อ</li>
                  </div>
                </div>
                <div className='indexBoxItems'>
                  <h6><i class="fa-solid fa-chalkboard-user"></i> TRAINNING</h6>
                  <div className='indexLiDesc'>
                    <li>บริการด้านการฝึกอบรม</li>
                    <li>ออกบูธ</li>
                    <li>Event</li>
                  </div>
                </div>
                <div className='indexBoxItems'>
                  <h6><i class="fa-solid fa-shirt"></i> LUANDRY UNIFORM</h6>
                  <div className='indexLiDesc'>
                    <li>Uniform General : บริการซักรีด ชุดทั่วไป</li>
                    <li>Curtain : บริการซักรีด ผ้าม่าน</li>
                    <li>Hotel : บริการซักรีด งานโรงแรม</li>
                    <li>Medical : บริการซักรีด งานโรงพยาบาล</li>
                    <li>Cleanroom ESD : บริการซักรีด งานห้องคลีนรูม</li>
                    <li>MAT : บริการซักรีด พรม</li>
                    <li>Tech Fire Suit : ตรวจสอบชุดดับเพลิง</li>
                    <li>Tech FR Uniform : ตรวจสอบชุดป้องกันไฟ</li>
                    <li>Tech Chem Suit : ตรวจสอบงานชุดเคมี</li>
                    <li>Tech Glove Clean : บริการซักถุงมือ</li>
                    <li>Tech Harness : บริการทำความสะอาด Harness</li>
                  </div>
                </div>
              </div>
              <div style={{display: "grid" , height: "max-content"}} className='indexGridRows'>
                <div className='indexBoxItems'>
                    <h6><i class="fa-brands fa-instalod"></i> SERVICE INSTALLATION</h6>
                    <div className='indexLiDesc'>
                      <li>Installation General : งานติดตั้งทั่วไป</li>
                      <li>Emergency Shower : งานบริการอ่างล้างตา</li>
                      <li>Safety Sign : งานบริการติดตั้งป้าย</li>
                      <li>Electrical System : งานบริการไฟฟ้า วางระบบ</li>
                      <li>IT Service Support : งานบริการไฟฟ้า วางระบบ</li>
                      <li>Welding : งานเชื่อม ขึ้นรูปตัวอย่าง</li>
                      <li>Construction : งานก่อสร้าง ติดตั้ง รับเหมา</li>
                      <li>Machine : เครื่องจักร ซ่อมบำรุง คอมเพรชเซอร์</li>
                      <li>Paint : งานตีเส้นจราจร ติดตั้งที่กั้นจราจร</li>
                      <li>Harness Inspec Installation : งานติดตั้ง ตรวจสอบงานที่สูง</li>
                      <li>Compressor Machine : งานติดตั้ง คอมเพรชเซอร์</li>
                      <li>Lab Other</li>
                    </div>
                </div>
                <div className='indexBoxItems'>
                  <h6><i class="fa-solid fa-code-compare"></i> RENTAL</h6>
                  <div className='indexLiDesc'>
                      <li>SCBA : เช่ายืม อุปกรณ์ SCBA</li>
                      <li>Air Line : เช่ายืม อุปกรณ์</li>
                      <li>GAS Detector : เช่ายืม อุปกรณ์</li>
                      <li>Rescue Set : เช่ายืม อุปกรณ์ช่วยเหลือฉุกเฉิน</li>
                      <li>AED : เช่ายืม อุปกรณ์ AED</li>
                      <li>Alcohol : เช่ายืม อุปกรณ์เครื่องวัดแอลกอฮอล์</li>
                      <li>Harness : เช่ายืม อุปกรณ์ที่สูง</li>
                      <li>FIRE SUIT : เช่ายืม ชุดดับเพลิง</li>
                      <li>FIRE Equipment : เช่ายืม อุปกรณ์ดับเพลิง</li>
                      <li>Environmental equipment : เช่ายืม อุปกรณ์เครื่องวัด แสง สี เสียง</li>
                      <li>SELECT SAFETY : เช่ายืมตู้</li>
                  </div>
                </div>
              </div>
              <div>
              <div className='indexBoxItems'>
                  <h6><i class="fa-solid fa-flask-vial"></i> LAB TECHNIC</h6>
                  <div className='indexLiDesc'>
                      <li>SCBA Refill : อัดอากาศ</li>
                      <li>SCBA Docment : เอกสารยุทธภัณฑ์</li>
                      <li>SCBA Clean MA repair : ซ่อมบำรุง ไฮรโดรเทส SCBA</li>
                      <li>Gas Detector : ตรวจวัด บำรุง เครื่องวัดแก๊ส</li>
                      <li>Environmental : เครื่องมือวัดสิ่งแวดล้อม</li>
                      <li>Alcohol Detector : เครื่องวัด alcohol calibrate</li>
                      <li>AED Inspect Repair : ซ่อมบำรุง AED</li>
                      <li>FIRE Extingushier : ตรวจ บำรุง ถังดับเพลิง</li>
                      <li>FIRE PUMP : ตรวจบำรุงงานไฟปั๊ม</li>
                      <li>Glove Inpection : บริการตรวจสอบบริการถุงมือ</li>
                      <li>LAB Helmet Inspection : งานบริการ หมวกนิรภัย</li>
                      <li>Sizing Safety Shoe : วัดรองเท้า ตรวจสุขภาพเท้า</li>
                      <li>Sizing Mask Repirator Fittest : บริการตรวจหน้ากาก</li>
                      <li>Survey Train LOTO : บริการตรวจเครื่องมือตัดพลังงาน</li>
                      <li>Harness Inspection : งานบริการ ตรวจสอบอุปกรณ์</li>
                  </div>
                </div>
                <div className='indexBoxItems'>
                  <h6><i class="fa-solid fa-laptop"></i> IT MEDIA</h6>
                  <div className='indexLiDesc'>
                      <li>Web : งานเว็บไซด์ ออกแบบเว็บไซด์</li>
                      <li>Software : งานออกแบบโปรแกรม เขียนโปรแกรม</li>
                      <li>Advertise Safety Sign : งานป้าย ออกแบบป้าย</li>
                      <li>Advertise : สื่อสิ่งพิมพ์</li>
                      <li>Advertise Add Project : งานเพิ่มสินค้า</li>
                      <li>All Catalog : งานออกแบบแคตตาล็อค</li>
                      <li>Boot Event : งานออกแบบบูธ อีเว้นท์ กิจกรรมสัมมนา</li>
                      <li>IT Other Media Service : งานสื่อสิ่งพิมพ์ ออกแบบโปรแกรม เว็บไซต์ บริการอื่นๆ</li>
                  </div>
                </div>
              </div>
            </div>
        </div>
        {/* <div style={{marginTop: "80px"}} className='indexHeaderContentsContainer indexBannerHeadersGrid'>
            <div class="">

            </div>
            <div className='indexBannerHuman'>
              <img src="/new_call.jpg" alt="" />
            </div>
        </div> */}
        <div style={{marginTop: "80px"}} className='indexHeaderContentsContainer'>
            <div className='indexWithBg'>
              <h3>ABOUT US</h3>
              <p style={{color: "white"}}>PROFRESSIONAL SERVICE & BEST PRODUCTS</p>
              <p>เราคือผู้นำด้านการบริการ จัดจำหน่าย และนำเข้าอุปกรณ์ ชุดดับเพลิง งานผจญเพลิง และอุปกรณ์ต่างๆที่ใช้ในงานดับเพลิง, 
                ชุดป้องกันภัยในงานเสี่ยงต่างๆ อุปกรณ์สำหรับงานอพยพสำหรับเหตุฉุกเฉินเพื่อลดการสูญเสียและบาดเจ็บ สัญลักษณ์และการบ่งชี้ 
                จัดสัมนา/อบรมหลักสูตรด้านความปลอดภัยต่างๆ และเป็นผู้นำการควบคุมการใช้งานด้านพลังงาน และแผนการรองรับเพื่อแผนงานฉุกเฉิน 
                รวมไปถึงเทคโนโลยีสมัยใหม่เพื่อใช้ในโรงงานอุตสาหกรรมครบวงจร
              </p>
            </div>
        </div>
        <div style={{marginTop: "80px"}} className='indexHeaderContentsContainer'>
            <div className=''>
              <h3 style={{fontSize: "18px"}}>รูปภาพ</h3>
              <div className="training_topics">
                  <div className="tr_images">

                      <img src='https://training.piyamanee.com/wp-content/uploads/2023/06/LINE_ALBUM_%E0%B8%AA%E0%B8%B1%E0%B8%A1%E0%B8%A1%E0%B8%99%E0%B8%B2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AD%E0%B8%B2%E0%B8%81%E0%B8%B2%E0%B8%A8%E0%B9%83%E0%B8%99%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%AD%E0%B8%B1%E0%B8%9A%E0%B8%81%E0%B8%B2%E0%B8%A8-22052023_%E0%B9%92-1024x683.jpg' />
                      <img src='https://training.piyamanee.com/wp-content/uploads/2023/06/LINE_ALBUM_Chemical-Safety-Part-4-21042023_%E0%B9%92%E0%B9%93%E0%B9%90%E0%B9%96%E0%B9%90%E0%B9%93-1-1024x683.jpg' />
                      <img src='https://training.piyamanee.com/wp-content/uploads/2023/06/LINE_ALBUM_ROPE-ACCESS-BEST-PERFORMANT_%E0%B9%92%E0%B9%92%E0%B9%91%E0%B9%91%E0%B9%91%E0%B9%91_2-1024x683.jpg' />

                      <img src='https://training.piyamanee.com/wp-content/uploads/2024/09/LINE_ALBUM_%E0%B8%AA%E0%B8%B1%E0%B8%A1%E0%B8%A1%E0%B8%99%E0%B8%B2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%88%E0%B8%B1%E0%B8%94%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AD%E0%B8%B2%E0%B8%81%E0%B8%B2%E0%B8%A8%E0%B9%83%E0%B8%99%E0%B8%97%E0%B8%B5%E0%B9%88%E0%B8%AD%E0%B8%B1%E0%B8%9A%E0%B8%81%E0%B8%B2%E0%B8%A8-22052023_240-1024x683.jpg' />
                      <img src='https://training.piyamanee.com/wp-content/uploads/2024/09/LINE_ALBUM_%E0%B8%AA%E0%B8%B1%E0%B8%A1%E0%B8%A1%E0%B8%99%E0%B8%B2%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%95%E0%B8%AD%E0%B8%9A%E0%B8%AA%E0%B8%99%E0%B8%AD%E0%B8%87%E0%B8%95%E0%B9%88%E0%B8%AD%E0%B8%AA%E0%B8%A0%E0%B8%B2%E0%B8%A7%E0%B8%B0%E0%B8%89%E0%B8%B8%E0%B8%81%E0%B9%80%E0%B8%89%E0%B8%B4%E0%B8%99-26052023_240-1024x683.jpg' />
                      <img src='https://training.piyamanee.com/wp-content/uploads/2024/09/LINE_ALBUM_LOTO-30062023_240911_1-1024x683.jpg' />

                  </div>
              </div>
            </div>
        </div>
        <div style={{marginTop: "20px"}} className='indexHeaderContentsContainer indexHeaderControllerGrid'>
            <div className='indexBottomDesc'>
              <p style={{color: "black"}}>PROFRESSIONAL SERVICE & BEST PRODUCTS</p>
              <div className='indexLiDesc bottomFooterLi'>
                    <li>SERVICE INSTALLATION</li>
                    <li>LAB TECHNIC</li>
                    <li>LUANDRY UNIFORM</li>
                    <li>RENTAL</li>
                    <li>IT MEDIA</li>
                  </div>
            </div>
            <div className='indexBottomDesc'>
              <p style={{color: "black"}}>CONNECTION</p>
              <div className='indexLiDesc bottomFooterLi'>
                    <li><NavLink to='https://www.anusornbestsafe.com/' target='_blank'>anusornbestsafe.com</NavLink></li>
                    <li><NavLink to='https://piyamanee.com/' target='_blank'>piyamanee.com</NavLink></li>
                    <li><NavLink to='https://yokmanee.com/' target='_blank'>yokmanee.com</NavLink></li>
                  </div>
            </div>
            <div className='indexBottomDesc'>
              <p style={{color: "black"}}>CONTACT</p>
              <div className='indexLiDesc bottomFooterLi'>
                <div><i class="fa-brands fa-facebook" style={{color: "#0866ff"}}></i> <NavLink to='https://www.facebook.com/PGT.Center/' target='_blank'> Piyamanee Training Center  </NavLink> </div>
                <div><i class="fa-brands fa-instagram" style={{color: "#e019eb"}}></i> <NavLink to='https://www.instagram.com/piyamaneetraining/' target='_blank'> piyamaneetraining </NavLink> </div>
                <div style={{color:"gray"}}><i class="fa-solid fa-envelope" style={{color: "black"}}></i> E-mail : piyamaneetraining@gmail.com </div>
              </div>
            </div>
        </div>
    </div>
  )
}

export default Banner